export default __webpack_public_path__ + "static/media/Iconly-Bold-Add User.6b2bfad9.svg";